import { compose, withHandlers, withProps } from 'recompose'
import { connect } from 'react-redux'
import { showStoreLocatorModalInAppointmentMode } from 'actions/storeLocator'
import StoreDetails from './StoreDetails'
import { formatAddress } from '../../helpers'
import { formatPhoneNumber } from 'helpers/phone-number'

const withStoreDetails = withProps(({
  currentStore: {
    storeNumber,
    phoneNumbers,
    address,
    storeDetailsUrl
  } = {}
}) => ({
  storeNumber,
  storePhoneNumber: phoneNumbers ? phoneNumbers[0] : undefined,
  storeStreetAddress: address ? address.address1 : undefined,
  storeCityAddress: address ? formatAddress(address) : undefined,
  storeFormattedPhone: phoneNumbers ? formatPhoneNumber(phoneNumbers[0]) : undefined,
  storeDetailsUrl
})
)

const withHandleStoreLocationClick = withHandlers({
  handleStoreLocationClick: ({ showStoreLocatorModalInAppointmentMode }) => (e) => {
    e.stopPropagation()
    showStoreLocatorModalInAppointmentMode()
  }
})

export default compose(
  connect(null, { showStoreLocatorModalInAppointmentMode }),
  withStoreDetails,
  withHandleStoreLocationClick
)(StoreDetails)
